import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CreateBillByVendor from "../components/CreateBillByVendor";


const CreateBillPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='Create New Bill' />

                <CreateBillByVendor />

            </MasterLayout>
        </>
    );
};

export default CreateBillPage;
